export default __webpack_public_path__ + "static/media/mission.3fec479d.png";